import React, { useEffect } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import './FormComp.css'
import { API_URL, CAMPAIGN_ID_CONTACT } from '../../../../config/config';
import axios from 'axios';

const SuccessEnqComp = () => {

    const [searchParams] = useSearchParams();
    const cId = searchParams.get('c_id') || null;
    const campaignId = cId && cId.trim() !== "" ? cId : CAMPAIGN_ID_CONTACT;
    
    const templateId = searchParams.get('template_id') || null;
    const batchId = searchParams.get('batch_id') || null;
    const emailId = searchParams.get('email_id') || null;

    useEffect(() => {

        if(campaignId !== "" && campaignId !== null && templateId !== "" && templateId !== null && batchId !== "" && batchId !== null && emailId !== "" && emailId !== null) {
            (async() => {
                try {

                    const formData = new FormData();
                    formData.append("campaign_id", campaignId);
                    formData.append("template_id", templateId);
                    formData.append("batch_id", batchId);
                    formData.append("email_id", emailId);

                    const response = await axios.post(
                        `${API_URL}vnext/campaign/marketing/emails/track/enquiry`,
                        formData,
                        { headers: { "Content-Type": "multipart/form-data" }}
                    );

                    if (response.status >= 200 && response.status <= 299 && response.data.status === 200) {
                        console.log("Campaign captured successfully!");
                    } else {
                        console.warn("Failed to capture campaign, please check the response.", response);
                    }

                } catch (error) {
                    console.error("Failed to capture campaign, please check the response.", error.message);
                }
            })();
        }

    }, [campaignId, templateId, batchId, emailId]);


    return (
        <div>
            <>
                <div className='successForm'>
                    <div className='position-absolute top-50 start-50 translate-middle text-center shadow p-5 rounded'>
                        <div className='icon mb-4'>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM363.3 203.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 297.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l128-128z"/></svg>
                        </div>
                        <div className='details'>
                            <h2>Success</h2>
                            <p>Thank you for showing the interest an enquiry. <br/> Our Team will connect with you.</p>
                        </div>
                        <div className='goToHomeBtn rounded  py-2 px-3'>
                            <Link to='/' className='text-decoration-none text-white'>Go To Home Page</Link>
                        </div>
                    </div>
                </div>
            </>
        </div>
    )
}
export default SuccessEnqComp